import React from 'react';
import { useParams, useRouter } from 'next/navigation';

const AddProducts: React.FC = () => {
    const handleButtonClick = () => {
        window.location.href = '/';
    };

    return (
        <div className="">
            <div className='mb-20'> Browse the website to start adding products to a project. </div>
            <div className="w-[240px] h-[288px] border-2 border-dotted border-gray-400 flex items-center justify-center">
                <button
                    onClick={handleButtonClick}
                    className="border px-18 py-[4.5px] fontSize14-sm bg-orange-100 rounded-full items-center justify-center"
                >
                    Add products
                </button>
            </div>
        </div>
    );
};

export default AddProducts;
